import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { SignUpMutationRequest, SignUpMutationResponse, SignUp400 } from "../types/SignUp";
import type { UseMutationOptions } from "@tanstack/react-query";

 type SignUpClient = typeof client<SignUpMutationResponse, SignUp400, SignUpMutationRequest>;
type SignUp = {
    data: SignUpMutationResponse;
    error: SignUp400;
    request: SignUpMutationRequest;
    pathParams: never;
    queryParams: never;
    headerParams: never;
    response: SignUpMutationResponse;
    client: {
        parameters: Partial<Parameters<SignUpClient>[0]>;
        return: Awaited<ReturnType<SignUpClient>>;
    };
};
/**
 * @summary Sign Up
 * @link /api/sign-up
 */
export function useSignUp(options: {
    mutation?: UseMutationOptions<SignUp["response"], SignUp["error"], SignUp["request"]>;
    client?: SignUp["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async (data) => {
            const res = await client<SignUp["data"], SignUp["error"], SignUp["request"]>({
                method: "post",
                url: `/api/sign-up`,
                data,
                headers: { "Content-Type": "text/json", ...clientOptions.headers },
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}